import styled from 'styled-components';

export const CardContainer = styled.div`
  .cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
  }

  .balanceValue {
    display: flex;
    align-items: flex-start;
    margin-left: 10px;
  }

  .buttons {
    display: flex;
    margin: 0 10px;
    justify-content: flex-end;
  }

  @media (max-width: 768px) {
    .cards {
      grid-template-columns: 1fr;
      gap: 12px;
    }
  }
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  background-color: rgba(0, 0, 0, 0.01);
  border-radius: 12px;

  .start-report {
    width: 200px;
    margin-top: 24px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;

  .start-report {
    max-width: 200px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const HistoryGraph = styled.div`
  height: 300px;
  display: flex;
  margin-top: 24px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

export const BarGraph = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 2500px;
  overflow: hidden;
  margin-top: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;
